import React from "react"
import "../style.css"
import Info from "../components/info"
import About from "../components/about"
import Interests from "../components/interests"
import Publications from "../components/publications"
import Education from "../components/education"
import Work from "../components/work"
import Layout from "../components/layout"
import Contact from "../components/contact";


function index() {
    return (
        <Layout>
            <div className={"welcome-spacer"} style={{paddingBottom: `15vh`}}>
                <Info/>
            </div>
            <div style={{paddingTop: `20vh`}}>
                <About/>
            </div>
            <div style={{paddingTop: `40vh`}}>
                <Interests/>
            </div>
            <div style={{paddingTop: `20vh`}}>
                <Publications/>
            </div>
            <div style={{paddingTop: `20vh`}}>
                <Work/>
            </div>
            <div style={{paddingTop: `25vh`}}>
                <Education/>
            </div>
            <div style={{paddingTop: `30vh`}}>
                <Contact/>
            </div>
        </Layout>

    )
}

export default index
